import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { TLojaByID, TLojas } from "../types";
import  getLojasById from "./services";

export const actionGetLojaById = createAsyncThunk(
  "GET_LOJA_BY_ID",
  async (_, { getState }) => {
    const { getLojas: { lojaSelected } }: any = getState();

    const { data } = await getLojasById(lojaSelected)
    return data
  }
)

const slicesGetLojaById = createSlice({
  name: "GET_LOJA_BY_ID",
  initialState: {
    data: {} as TLojaByID,
    status: "",
  },
  reducers: {
    actionSelectLoja: (state, { payload }) => {
      
    },
  },
  extraReducers: {
    [`${actionGetLojaById.pending}`]: (state) => {
      state.status = "loading"
    },
    [`${actionGetLojaById.fulfilled}`]: (state, { payload }) => {
      state.status = "success"
      state.data = payload
    },
    [`${actionGetLojaById.rejected}`]: (state, payload) => {
      state.status = "failed"
    },
  }
})

export default slicesGetLojaById.reducer
export const { actionSelectLoja } = slicesGetLojaById.actions